// extracted by mini-css-extract-plugin
export var addButton = "_q8-0";
export var border = "_q8-8";
export var check = "_q8-h";
export var danger = "_q8-6";
export var dropdownContainer = "_q8-1";
export var editModalBody = "_q8-j";
export var footerContainer = "_q8-i";
export var fullWidth = "_q8-a";
export var hide = "_q8-9";
export var icon = "_q8-3";
export var input = "_q8-7";
export var inputFlex = "_q8-b";
export var inputWrapper = "_q8-c";
export var manualFocus = "_q8-5";
export var optionButton = "_q8-4";
export var pillWrapper = "_q8-e";
export var pointer = "_q8-2";
export var showOverflow = "_q8-f";
export var tagsFlex = "_q8-d";
export var xButton = "_q8-g";